import { useState } from 'react';
import type { DiemDanhDauGio } from '@/services/DiemDanhDauGio';
import { getTrongMuonThang } from '@/services/TrongMuonThang/trongmuonthang';
export default () => {
    const [danhSachh, setDanhSachh] = useState<DiemDanhDauGio.Record[]>([]);
    const [record, setRecord] = useState<DiemDanhDauGio.Record>();
    const [loading, setLoading] = useState<boolean>(true);
    const [total, setTotal] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [limit, setLimit] = useState<number>(10);
    const [cond, setCondition] = useState<any>({});
    const [filterInfo, setFilterInfo] = useState<any>({});
  
    const getTrongMuonThangModel = async (conId?: string ,donViId?: string, thang?: number, nam?: number) => {
      setLoading(true);
      const response = await getTrongMuonThang({ page, limit, cond, conId, donViId, thang, nam });
      setDanhSachh(response?.data?.data?.result ?? []);
      setTotal(response?.data?.data?.total);
      setLoading(false);
    };
    return {
        danhSachh,
        loading,
        setLoading,
        getTrongMuonThangModel,
        total,
        setTotal,
        page,
        setPage,
        limit,
        setLimit,
        cond,
        setCondition,
        filterInfo,
        setFilterInfo,
        setRecord,
        record,
      };
    };  